module.exports = __webpack_public_path__ + "static/media/logo.53bbe7a5.png";